/**
 * Asynchronously loads the component for CompanyProfile
 */

import { lazyLoad } from "utils/loadable";

export const CompanyProfile = lazyLoad(
  () => import("./index"),
  (module) => module.CompanyProfile
);
